export const filterUniqueUsedVisualValues = (
    variants: Array<GQL.IProductVariant>,
    visualAttribute: GQL.IAttribute | undefined
) => {
    const uniqueVisualValues = new Array<GQL.IAttributeValue>();
    if (visualAttribute == undefined) {
        return uniqueVisualValues;
    }

    for (const variant of variants) {
        const usedVisualValueId = (variant.definition || {}).visual;
        if (usedVisualValueId == undefined) {
            continue;
        }

        const tempValue = (visualAttribute.values || []).find(v => v.id == usedVisualValueId);
        if (tempValue != undefined) {
            if (!uniqueVisualValues.some(v => v.id == tempValue.id)) {
                uniqueVisualValues.push(tempValue);
            }
        }
    }

    return uniqueVisualValues;
};



// WEBPACK FOOTER //
// ./src/helpers/Variants/filterUniqueUsedVisualValues.ts